function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgMedicalSecondOpinion = function SvgMedicalSecondOpinion(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M31.425 21.482v19.373H14.969l-7.786 6.778V21.482l5.828.006z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M31.425 36.665h3.87l11.772 9.768V7.198H9.519v14.677"
  }));
};
export default SvgMedicalSecondOpinion;